import type {
  ComponentValueResponse,
  SaveComponentValueResponse,
  TrapetsLookupInput,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getFlowInstanceValue(instanceId: string) {
  return get<ComponentValueResponse>(`${BASE}/${instanceId}/trapets-lookup/flow-instance-value`);
}

export function searchAndSave(instanceId: string, input: TrapetsLookupInput) {
  return post<SaveComponentValueResponse>(
    `${BASE}/${instanceId}/trapets-lookup/flow-instance-value`,
    input,
  );
}
